import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RevealMask } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";
import { industries } from "@/data/content";

export default function IndustriesTeaser() {
  return (
    <section
      data-testid="industries-teaser"
      className="border-y border-bone/10 bg-ink text-bone"
    >
      <div className="mx-auto max-w-[1600px] px-5 py-20 sm:py-24 md:py-28 lg:py-32 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <div className="grid gap-6 sm:gap-8 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <ScrambleText
              as="p"
              text="Industries"
              className="mb-4 block text-xs font-bold uppercase tracking-[0.22em] text-accent"
            />
            <RevealMask
              as="h2"
              className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-bone md:text-6xl"
            >
              Sectors we
            </RevealMask>
            <RevealMask
              as="h2"
              delay={0.08}
              className="font-serif text-4xl font-normal italic leading-[0.95] text-bone/70 md:text-6xl"
            >
              know deeply.
            </RevealMask>
          </div>
          <p className="self-end text-base leading-relaxed text-bone/60 lg:col-span-5 lg:col-start-8">
            Category fluency shortens the distance between insight and impact. From automobiles to fashion, F&amp;B to real estate — these are the worlds we build brands in.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-3 sm:mt-12 md:mt-16">
          {industries.map((ind, i) => (
            <motion.div
              key={ind.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.5, delay: (i % 6) * 0.04, ease: [0.76, 0, 0.24, 1] }}
            >
              <Link
                to={`/industries#${ind.slug}`}
                data-testid={`industries-teaser-chip-${ind.slug}`}
                className="inline-flex items-center rounded-full border border-bone/20 px-5 py-2.5 text-sm font-medium text-bone/85 transition-colors duration-300 hover:border-accent hover:bg-accent hover:text-ink"
              >
                {ind.name}
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 md:mt-14">
          <Link
            to="/industries"
            data-testid="industries-teaser-cta"
            className="group inline-flex items-center gap-2 border border-bone/30 px-6 py-4 text-sm font-bold uppercase tracking-[0.14em] text-bone transition-colors hover:border-accent hover:bg-accent hover:text-ink"
          >
            Explore all industries
            <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
